import React from "react";

import FormCIForAirport from "../ci/formCiForAirport";
import FormCIForShip from "../ci/formCiForShip";
// import FormCIForERPShip from "../ci/formCIForERPShip";
import FormCIForShipProforma from "../ci/formCiForShipProforma";

const CommercialInvoiceViewer = (props) => {
  switch (props.data.loadingtype_id) {
    case 0:
      // return <FormCIForERPShip {...props} />;
      return <FormCIForAirport {...props} />;
    case 1:
      return <FormCIForAirport {...props} />;
    case 5:
      /** Check type here for Ship
       *
       */
      switch (props.data.type) {
        case 0:
          return <FormCIForShip {...props} />;
        case 2:
          return <FormCIForShipProforma {...props} />;
        default:
          return `No form found for type: ${props?.data?.type}`;
      }

    default:
      return `No form found for loadingtype id: ${props?.data?.loadingtype_id}`;
  }
};

export default CommercialInvoiceViewer;
